import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=6b2a65cb&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=6b2a65cb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a65cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2a65cb')) {
      api.createRecord('6b2a65cb', component.options)
    } else {
      api.reload('6b2a65cb', component.options)
    }
    module.hot.accept("./SearchResult.vue?vue&type=template&id=6b2a65cb&scoped=true", function () {
      api.rerender('6b2a65cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/SearchResult.vue"
export default component.exports